import dayjs from 'dayjs'
export default date => dayjs(date).format('YYYY/M/D')
